<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.general}}</div>
    </v-card-title>
    <v-card-title>
      <div class="body-2">{{labels.quoteInfo}}</div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.product}}</v-subheader>
            <div>{{commonForm.product}} - {{query.product}}</div>
          </v-flex>
          <v-flex xs6></v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.busCls}}</v-subheader>
            <div>{{cargoForm.busCls}} - {{query.busCls}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.acceptDate}}</v-subheader>
            <div v-if="commonForm.acceptDate">{{formatDisplayDate(commonForm.acceptDate)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.startDate}}</v-subheader>
            <div v-if="commonForm.startDate">{{formatDisplayDate(commonForm.startDate)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.endDate}}</v-subheader>
            <div v-if="commonForm.endDate">{{formatDisplayDate(commonForm.endDate)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.comdty}}</v-subheader>
            <div>{{cargoForm.comdty}} - {{query.comdty}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.pack}}</v-subheader>
            <div>{{cargoForm.pack}} - {{query.pack}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.si}}</v-subheader>
            <div v-if="cargoForm.si !== null">{{formatDisplayNumber(cargoForm.si, 2)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.printSi}}</v-subheader>
            <div v-if="cargoForm.printSi != null">{{printSi(cargoForm.printSi)}}</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.siCurr}}</v-subheader>
            <div>{{cargoForm.siCurr}} - {{formatDisplayNumber(cargoForm.siCurrRate, 7)}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.siUplift}}</v-subheader>
            <div v-if="cargoForm.siUplift !== null">{{cargoForm.siUplift}}%</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.billCurr}}</v-subheader>
            <div>{{commonForm.billCurr}} - {{formatDisplayNumber(commonForm.billCurrRate, 7)}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.tolerance}}</v-subheader>
            <div v-if="cargoForm.tolerance !== null">{{cargoForm.tolerance}}%</div>
            <div v-else> - </div>
          </v-flex>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{labels.subjectMatter}}</v-subheader>
            <div v-if="cargoForm.subjectMatter !== null">
              <v-textarea v-model="cargoForm.subjectMatter" readonly auto-grow></v-textarea>
            </div>
            <div v-else> - </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { printSi } from '@/const/underwriting/cargo'

export default {
  data() {
    return {
      labels: {
        quoteInfo: 'Quotation Information',
        general: 'General',
        product: 'Product',
        busCls: 'Business Class',
        comdty: 'Commodity',
        pack: 'Packing Type',
        siCurr: 'Sum Insured Currency',
        si: 'Sum Insured/Limit per Conveyance',
        billCurr: 'Billing Currency',
        tolerance: 'Tolerance on Credit Amount % (+/-)',
        siUplift: 'Sum Insured Uplift %',
        startDate: 'Start Date',
        endDate: 'End Date',
        acceptDate: 'Acceptance Date',
        subjectMatter: 'Subject Matter',
        printSi: 'Print SI'
      }
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    cargoForm() {
      return this.$store.state.agency.quotation.cargoForm
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    printSi(value) {
      return printSi[value]
    }
  }
}
</script>

<style lang="scss">

</style>
